import type { ComponentType } from 'react';
import { createContext } from 'react';

import type { I18nService } from '@shared/types/i18n';

import displayName from '@shared/utils-frontend/display-name';

interface ContextProps {
  i18n: I18nService;
}

// @ts-expect-error missing properties
const I18nContext = createContext<I18nService>({});

export const withI18n = <P extends ContextProps>(
  Component: ComponentType<P>,
) => {
  const component = (props: Omit<P, 'i18n'>) => (
    <I18nContext.Consumer>
      {(i18n: I18nService) => (
        // @ts-expect-error we expect that it can be overwritten in the unit tests
        <Component i18n={i18n} {...(props as P)} />
      )}
    </I18nContext.Consumer>
  );

  component.displayName = displayName(Component);

  return component;
};

export default I18nContext;
